module.exports = "<!--\n  not content any html, is only for call commons ionic methods wrapped in component methods\n-->"